<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card>
      <v-app-bar flat dark color="primary">
        <v-toolbar-title>Reject Referral</v-toolbar-title>
      </v-app-bar>
      <v-card-title>
        <v-layout wrap>
          <v-flex xs3>Referral:</v-flex>
          <v-flex xs9>{{ referral.company_name }}</v-flex>
          <v-flex xs3>Referrer:</v-flex>
          <v-flex xs9>{{ referral.referrer.name }}</v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-select :items="closeReasons" v-model="rejectReason" label="Reason for rejecting" flat dense></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="prmiary" text @click="close">Close</v-btn>
        <v-btn color="accent" @click="save">Reject</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'reject-referral-form',
  components: {},
  data: () => ({
    rejectReason: null,
    closeReasons: [
      "Platform - Couldn't find SME finance",
      'Platform - Successful funding',
      'Platform - Never made contact',
      'Platform - None responsive',
      'Platform - SME no longer eligible',
      'SME - No longer require finance',
      'SME - Found/sought finance elsewhere',
      'Bank - Unreferred SME',
      'Platform - Test data',
      'Platform - Duplicate data',
      'Platform – Invalid contact data'
    ]
  }),
  props: ['referral', 'dialog'],
  computed: {},
  methods: {
    ...mapActions(['updateReferral']),
    close() {
      this.$emit('changed', false);
    },
    save() {
      this.$emit('changed', this.rejectReason);
    }
  }
};
</script>

<style scoped></style>
